import React, { useState, useEffect } from "react";
import Loading from "../components/loading";
import { storeLocalStorage } from "../function/functions";
import secureLocalStorage from "react-secure-storage";
import Logo from "../assets/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { sendOtp } from "../store/features/webUtilitiesSlice";
import { LoginSocialGoogle } from "reactjs-social-login";
import { useNavigate } from "react-router-dom";
import { GoogleLoginButton } from "react-social-login-buttons";
import {
  GOOGLE_CLIENT_ID,
  GOOGLE_LOGIN_ENDPOINT,
  LOGINENDPOINT,
} from "../config/ApisCollection";
import axios from "axios";

const LoginWithPass = () => {
  const { errorMsg } = useSelector((state) => state.webUtilities);
  // const dispatch = useDispatch();
  // let history = useNavigate();
  const [isLoading] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userPass, setUserPass] = useState("");
  const [errorMsgs, setErrorMsg] = useState("");
  const [continueBtn, setContinueBtn] = useState(false);
  const [socialBtnStatus, setSocialBtnStatuts] = useState(true);

  // Social login
  const [provider, setProvider] = useState("");
  const [profile, setProfile] = useState(null);
  const [social_Cred, setSocialCred] = useState({
    google: {
      client_id: GOOGLE_CLIENT_ID,
    },
  });

  const validateEmail = (email) => {
    // Regular expression for validating email addresses
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  // Google respones handler
  const handleSocialResponse = async (provider, data) => {
    setProvider(provider);

    if (data && data.email) {
      const request_body = {
        isSocial: provider,
        socialres: {
          access_token: data.access_token,
          scope: data.scope,
          sub: data.sub,
          name: data.name,
          given_name: data.given_name,
          email: data.email,
        },
      };
      const request_header = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      try {
        const response = await axios.post(
          GOOGLE_LOGIN_ENDPOINT,
          request_body,
          request_header
        );

        storeLocalStorage("accessToken", response.data.accessToken);
        storeLocalStorage("refreshToken", response.data.refreshToken);
        storeLocalStorage("isLoggedIn", "true");
        storeLocalStorage("userEmail", data.email);

        window.location.href = "/";
      } catch (error) {
        setSocialBtnStatuts(true);
        setErrorMsg(
          error.response.data.error.message || "Something went wrong"
        );
      }
    }
    // console.log(data);
  };

  useEffect(() => {
    if (secureLocalStorage.getItem("userEmail")) {
      setUserEmail(secureLocalStorage.getItem("userEmail"));
      setContinueBtn(true);
    }
  }, []);

  const handleEmailChange = (event) => {
    const enteredEmail = event.target.value;
    if (validateEmail(enteredEmail)) {
      setErrorMsg("");
      setContinueBtn(true);
      secureLocalStorage.setItem("userEmail", enteredEmail);
    } else {
      setErrorMsg("Please enter a valid email address.");
    }
    setUserEmail(enteredEmail);
  };

  const handlePasswordChange = (even) => {
    const password = even.target.value;
    setUserPass(password);
  };

  if (isLoading) return <Loading />;
  const handleOtp = async () => {
    if (!continueBtn) {
      setErrorMsg("Please enter your valid email address.");
      return false;
    }

    const request_body = {
      email: userEmail,
      password: userPass,
    };
    const request_header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.post(
        LOGINENDPOINT,
        request_body,
        request_header
      );

      storeLocalStorage("accessToken", response.data.accessToken);
      storeLocalStorage("refreshToken", response.data.refreshToken);
      storeLocalStorage("isLoggedIn", "true");
      storeLocalStorage("userEmail", userEmail);

      window.location.href = "/";
    } catch (error) {
      setSocialBtnStatuts(true);
      setErrorMsg(error.response.data.error.message || "Something went wrong");
    }
  };

  return (
    <div className="manlay bg-white">
      <div className="bodyly mt-16">
        <div
          className={`logo w-full flex justify-center top-0 z-30 fixed py-2 pt-3 left-0 bg-white`}
        >
          <img
            loading="lazy"
            src={Logo}
            alt="logo"
            className="h-auto w-32 z-30"
            width={100}
            height={30}
          />
        </div>
        {socialBtnStatus ? (
          <div className="w-full sm:mt-28 mt-20 mb-10">
            <div className="text-center mb-3">
              <h1 className="title font-semibold text-3xl">Login</h1>
              <p className="font-normal text-sm">Unlock Your Best Self</p>
            </div>
            <input
              type="email"
              name="email"
              value={userEmail || ""}
              onChange={handleEmailChange}
              placeholder="your@email.com"
              className="inputbox mt-5 sm:text-base sm:px-4 sm:py-4 py-3 px-4 text-sm rounded-xl"
            />
            <input
              type="password"
              name="password"
              onChange={handlePasswordChange}
              placeholder="Password"
              className="inputbox mt-5 sm:text-base sm:px-4 sm:py-4 py-3 px-4 text-sm rounded-xl"
            />

            <div className="flex justify-center">
              <LoginSocialGoogle
                isOnlyGetToken={false}
                client_id={social_Cred.google.client_id || ""}
                onLoginStart={() => {
                  setSocialBtnStatuts(false);
                }}
                scope="profile email"
                onResolve={({ provider, data }) => {
                  handleSocialResponse(provider, data);
                }}
                onReject={(err) => {
                  setSocialBtnStatuts(true);
                }}
                className={"w-4/6 "}
              >
                <GoogleLoginButton style={{ fontSize: "12px" }} />
              </LoginSocialGoogle>
            </div>
            <p className="text-sm text-[red] text-center">
              {errorMsg || errorMsgs}
            </p>
            <div className="btmain w-11/12 mt-10 mx-auto text-center">
              <div
                onClick={handleOtp}
                className={`sm:w-full w-10/12 mx-auto font-medium text-xl bottontex bottonly sm:py-4 py-3 ${
                  continueBtn ? "bottonlyac" : "bg-gray-300"
                }`}
              >
                Login
              </div>
              <div className="tex mt-6">
                <span className="tex">Don’t have an account?</span>
                <a href="https://fastbetter.com" className="loginbotm">
                  Begin your journey
                </a>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="manlay content-center bg-white">
              <div className="text-center mb-3">
                {/* <h1 className="title font-semibold text-3xl">Please wait...</h1> */}
                <p className="font-normal text-sm">Please wait...</p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default LoginWithPass;
